module.exports = __webpack_public_path__ + "img/checklist.8bf21d3b.svg";